






































// this component for simple dialog confirmation. e.g: yes/no
import {
    Component, Model, Prop, Vue, Watch,
} from 'vue-property-decorator';
import CustomDialog from '@/components/global/CustomDialog.vue';
import { ProductTemplate } from '@/assets/interface/Product';
import index from '@/store';

@Component({
    components: {
        CustomDialog,
    },
})
export default class UpgradePlanDialog extends Vue {
    @Model('update:returnValue', { type: Boolean }) readonly value!: boolean;
    @Prop({ default: '' }) readonly header!:string;
    @Prop({ default: '300px' }) readonly contentHeight!:string;

    public upgradeInProgress = false;

    public onUpgradeClick(res: boolean) {}

    public emitReturnValue(event: any) {
        this.$emit('update:returnValue', event);
    }
}
